import { createListenerMiddleware } from '@reduxjs/toolkit';
import { createListenerEffect } from '@socialive/common';
import { getSessionFromGuestLink } from '~/store/accountInfo';
import { getBroadcast } from '~/store/joinBroadcast';

export const effect = createListenerEffect(
  'setGuestLinkAuthError<Listener>',
  async (action, { dispatch, getState, trigger }) => {
    await dispatch(getBroadcast.rejected(new Error('Sorry, your broadcast link has expired')));
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  actionCreator: getSessionFromGuestLink.rejected,
  effect,
});

export default middleware;
